import * as React from "react";
const SvgWarning = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, rx: 12, fill: "#FF3B3B", style: {
  fill: "#FF3B3B",
  fill: "color(display-p3 1.0000 0.2314 0.2314)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M12 7.33203V13.499", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 11.9984, cy: 16.6, r: 1.1, fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }));
export default SvgWarning;
